import { useTranslation } from 'react-i18next';

export default function Programming() {
  const { t } = useTranslation();
  
  const programs = [
    {
      id: 1,
      title: t('programming.playlist1.title'),
      description: t('programming.playlist1.description'),
      spotifyUrl: 'https://open.spotify.com/embed/playlist/1pHGGLAqNbjVy0WwzaFsNu?utm_source=generator',
    },
    {
      id: 2,
      title: t('programming.playlist2.title'),
      description: t('programming.playlist2.description'),
      spotifyUrl: 'https://open.spotify.com/embed/playlist/52eD7sUebkg5gZDvhJPYGN?utm_source=generator',
    },
    {
      id: 3,
      title: t('programming.playlist3.title'),
      description: t('programming.playlist3.description'),
      spotifyUrl: 'https://open.spotify.com/embed/playlist/3gwon2vt6lyO5nvdbKUaWD?utm_source=generator',
    },
    {
      id: 4,
      title: t('programming.playlist4.title'),
      description: t('programming.playlist4.description'),
      spotifyUrl: 'https://open.spotify.com/embed/playlist/505FmIh8icZp76YlX9GNza?utm_source=generator',
    },
    {
      id: 5,
      title: t('programming.playlist5.title'),
      description: t('programming.playlist5.description'),
      spotifyUrl: 'https://open.spotify.com/embed/playlist/3CWs6VkAcjPpaL27FmUDEY?utm_source=generator',
    },
    {
      id: 6,
      title: t('programming.playlist6.title'),
      description: t('programming.playlist6.description'),
      spotifyUrl: 'https://open.spotify.com/embed/playlist/36dmIlaITrcQR5bswD7mEx?utm_source=generator',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-amber-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl sm:text-6xl lg:text-7xl font-normal text-gray-900 mb-6 uppercase tracking-tight" style={{ fontFamily: 'Bebas Neue, Impact, sans-serif' }}>
            {t('programming.title')}
          </h2>
          <div className="w-24 h-1 bg-amber-700 mx-auto mb-8"></div>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            {t('programming.subtitle')}
          </p>
        </div>

        {/* Program Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 xl:gap-10">
          {programs.map((program) => (
            <div 
              key={program.id}
              className="bg-white p-4 sm:p-6 lg:p-8 xl:p-10 border border-stone-300 hover:border-orange-700 transition-all duration-300"
            >
              <h3 className="text-lg sm:text-xl lg:text-2xl xl:text-3xl text-stone-900 mb-2 sm:mb-3 lg:mb-4" style={{ fontFamily: 'Anton, sans-serif' }}>
                {program.title}
              </h3>
              <p className="text-sm sm:text-base lg:text-lg text-stone-600 leading-relaxed mb-4 sm:mb-6 lg:mb-8">
                {program.description}
              </p>
              <div className="w-full">
                <iframe 
                  data-testid="embed-iframe" 
                  style={{ borderRadius: '12px' }} 
                  src={program.spotifyUrl}
                  width="100%" 
                  height="352" 
                  frameBorder="0" 
                  allowFullScreen={true}
                  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
                  loading="lazy"
                  title={program.title}
                ></iframe>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}